import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError, showToast } from "../constants/toasts";
import { useAddMemberGroupMutation } from "../service/user";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getGroupApi: () => void;
}

export default function AddGroup({
  open,
  onClose,
  setOpen,
  getGroupApi,
}: AddCategoryModalProps) {
  const [addGroup] = useAddMemberGroupMutation();
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState(false);

  const handleAddTagGroup = async () => {
    setError(true);
    if (groupName.trim() === "") {
      showError("Group name is required");
      return;
    }

    try {
      let response;

      response = await addGroup({ groupName }).unwrap();

      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        setGroupName("");
        showToast("Group added successfully");
        getGroupApi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Group</h2>
            <div
              className="btn-close"
              onClick={() => setOpen(false)}
              tabIndex={0}
              role="button"
            >
              <CloseIcon />
            </div>
          </div>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault(); // prevent default page reload
              handleAddTagGroup();
            }}
          >
            <div className="control_group">
              <label htmlFor="group-name">Group Name</label>
              <TextField
                id="group-name"
                placeholder="Enter Group Name"
                fullWidth
                hiddenLabel
                value={groupName}
                inputProps={{ maxLength: 40 }}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setGroupName(e.target.value);
                  }
                }}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
